module.exports = __webpack_public_path__ + "img/stu_avatar_6.fdb74305.jpg";